// Publish date bata REAL time + past days compute garchha (Nepali format)
import NepaliDate from 'nepali-date-converter';

const NP_DIGITS = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
export const npDigits = (s) => String(s).replace(/\d/g, (d) => NP_DIGITS[+d]);

const MIN = 60 * 1000;
const HOUR = 60 * MIN;

const NEPALI_MONTHS = ['बैशाख', 'जेठ', 'असार', 'साउन', 'भदौ', 'असोज', 'कार्तिक', 'मंसिर', 'पुष', 'माघ', 'फागुन', 'चैत'];
const NEPALI_DAYS = ['आइतबार', 'सोमबार', 'मंगलबार', 'बुधबार', 'बिहिबार', 'शुक्रबार', 'शनिबार'];

// Calendar-day difference (midnight-based) — DST/timezone safe
function calendarDayDiff(date, now) {
  const a = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const b = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((b - a) / (24 * 60 * 60 * 1000));
}

// "१०:३० पूर्वाह्न" / "६:०५ अपराह्न"
export function formatClockNp(date) {
  let h12 = date.getHours();
  const mins = String(date.getMinutes()).padStart(2, '0');
  const ampm = h12 >= 12 ? 'अपराह्न' : 'पूर्वाह्न';
  h12 = h12 % 12 || 12;
  return `${npDigits(h12)}:${npDigits(mins)} ${ampm}`;
}

// BS date: "साउन ५ गते, बिहिबार" (+ वर्ष optional)
export function formatBsDateNp(input, { withYear = false, withWeekday = true } = {}) {
  const d = input instanceof Date ? input : new Date(input);
  if (!input || Number.isNaN(d.getTime())) return '';
  try {
    const nd = new NepaliDate(d);
    const month = NEPALI_MONTHS[nd.getMonth()] || '';
    const day = npDigits(nd.getDate());
    const weekday = NEPALI_DAYS[d.getDay()];
    const year = npDigits(nd.getYear());
    let out = `${month} ${day} गते`;
    if (withWeekday && weekday) out += `, ${weekday}`;
    if (withYear) out += ` ${year}`;
    return out;
  } catch {
    return d.toLocaleDateString('ne-NP');
  }
}

/**
 * News publish line — REAL publish time + past days:
 *  - <1 min      -> "भर्खरै"
 *  - <1 hour     -> "२५ मिनेट अघि"
 *  - today       -> "आज, १०:३० पूर्वाह्न"
 *  - yesterday   -> "हिजो, ६:१५ अपराह्न"
 *  - <7 days     -> "३ दिन अघि • साउन ५ गते"
 *  - older       -> "साउन ५ गते, बिहिबार २०८३" (BS)
 */
export function formatPublishNp(input) {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  if (diffMs >= 0 && diffMs < MIN) return 'भर्खरै';

  if (diffMs >= 0 && diffMs < HOUR) {
    const mins = Math.floor(diffMs / MIN);
    return `${npDigits(mins)} मिनेट अघि`;
  }

  const dayDiff = calendarDayDiff(d, now);

  if (dayDiff === 0) return `आज, ${formatClockNp(d)} बजे`;
  if (dayDiff === 1) return `हिजो, ${formatClockNp(d)} बजे`;

  if (dayDiff > 1 && dayDiff < 7) {
    const bs = formatBsDateNp(d, { withYear: false, withWeekday: false });
    return bs ? `${npDigits(dayDiff)} दिन अघि • ${bs}` : `${npDigits(dayDiff)} दिन अघि`;
  }

  // Future dates (wrong data) — just show BS date
  if (dayDiff < 0) return formatBsDateNp(d, { withYear: false, withWeekday: false });

  return formatBsDateNp(d, { withYear: true, withWeekday: true });
}

// Legacy helper — still used in some places
export function timeAgoNp(input) {
  if (!input) return 'भर्खरै';
  const d = new Date(input);
  const diff = Date.now() - d.getTime();
  if (Number.isNaN(d.getTime()) || diff < 0) return 'भर्खरै';

  if (diff < MIN) return 'भर्खरै';
  const mins = Math.floor(diff / MIN);
  if (diff < HOUR) return `${npDigits(mins)} मिनेट अघि`;

  const hours = Math.floor(diff / HOUR);
  if (hours < 24) return `${npDigits(hours)} घण्टा अघि`;

  const days = calendarDayDiff(d, new Date());
  if (days === 1) return 'हिजो';
  return formatPublishNp(input);
}